import { render, staticRenderFns } from "./MyBonuses.vue?vue&type=template&id=31106cca&"
import script from "./MyBonuses.vue?vue&type=script&lang=js&"
export * from "./MyBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports